import axios from "axios";
import { API_BASE_URL } from "./BaseURL";


export const contactService = {

  
  createContact: async (payload) => {
    const { data } = await axios.post(`${API_BASE_URL}/contact`, payload);
    return data;
  },

  getAllContacts: async ({ page = 1, limit = 10, search = "", isUnread } = {}) => {
    const params = { page, limit, search };

    if (isUnread !== undefined) {
      params.isUnread = isUnread;
    }

    const { data } = await axios.get(`${API_BASE_URL}/contact`, { params });
    return data;
  },


  getContactById: async (id) => {
    console.log(id)
    const { data } = await axios.get(`${API_BASE_URL}/contact/${id}`);
    return data;
  },


  deleteContactById: async (id) => {
    const { data } = await axios.delete(`${API_BASE_URL}/contact/${id}`);
    return data;
  },

  
  deleteAllContacts: async () => {
    const { data } = await axios.delete(`${API_BASE_URL}/contact`);
    return data;
  },

  getNewContactsCount: async()=>{
    const res = await axios.get(`${API_BASE_URL}/contact/new-counts`)
    return res.data
  }
};
